"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParallelVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class ParallelVfxStepArgs {
    constructor(children) {
        this.children = children;
        this.__typeName = "Parallel";
        this.id = (0, uuid_1.v4)();
    }
}
exports.ParallelVfxStepArgs = ParallelVfxStepArgs;
